import {errorActions} from "../ErrorHandler/errorHandler";
import api from "../../util/api";

export const actionTypes = {
    getVideosSearch: "getVideosSearch",
    setIsWriting: "setIsWriting",
    setIsLoading: "setIsLoading",
    setShowResults: "setShowResults",
    setTrackId: "setTrackId",
    clearSearcher: "clearSearcher",
};

const initialQueryState = {
    videosSearch: null,
    showResults: false,
    errorSearch: {},
    isWriting: "",
    isLoading: false,
    trackId: "",
    query: "",
};

export const queryReducer = (state = initialQueryState, action) => {
    switch (action.type) {
        case actionTypes.getVideosSearch: {
            const {query, videosSearch, errorSearch} = action.payload;

            return {...state, query, videosSearch, errorSearch};
        }
        case actionTypes.setIsWriting: {
            const {isWriting} = action.payload;

            return {...state, isWriting};
        }
        case actionTypes.setIsLoading: {
            const {isLoading} = action.payload;

            return {...state, isLoading};
        }

        case actionTypes.setShowResults: {
            const {showResults} = action.payload;

            return {...state, showResults};
        }

        case actionTypes.setTrackId: {
            const {trackId} = action.payload;

            return {...state, trackId};
        }

        case actionTypes.clearSearcher: {
            return initialQueryState;
        }

        default:
            return state;
    }
};

const setLoader = isLoading => ({
    type: actionTypes.setIsLoading,
    payload: {isLoading},
});

const _setShowResults = showResults => ({
    type: actionTypes.setShowResults,
    payload: {showResults},
});

export const queryActions = {
    getVideosSearch: ({t, query, trackId}) => dispatch => {
        if (!trackId) {
            dispatch(setLoader(true));
            //GENERAL search (/tracks)
            return api
                .get(`v2/api/tracks/search/${query}`, {
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                    },
                })
                .then(({data: {data = [], message = [{}]}}) => {
                    dispatch(setLoader(false));
                    dispatch(_setShowResults(true));
                    dispatch({
                        type: actionTypes.getVideosSearch,
                        payload: {
                            videosSearch: data,
                            errorSearch: !data?.length
                                ? {type: "light", text: t("SEARCH_RESULTS_PAGE.NOT_FOUND")}
                                : message[0],
                            query,
                        },
                    });
                })
                .catch(err => {
                    dispatch(_setShowResults(true));
                    dispatch(setLoader(false));
                    dispatch(errorActions.setErrorMessage(err.message));
                });
        } else if (trackId) {
            //search filtered by trackId:
            dispatch(setLoader(true));
            return api
                .get(`v2/api/tracks/${trackId}/search/${query}`, {
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                    },
                })
                .then(({data: {data = [], message = [{}]}}) => {
                    dispatch(_setShowResults(true));
                    dispatch(setLoader(false));
                    dispatch({
                        type: actionTypes.getVideosSearch,
                        payload: {
                            videosSearch: data,
                            errorSearch: !data?.length
                                ? {type: "light", text: t("SEARCH_RESULTS_PAGE.NOT_FOUND")}
                                : message[0],
                            query,
                        },
                    });
                })
                .catch(err => {
                    dispatch(_setShowResults(true));
                    dispatch(setLoader(false));
                    dispatch(errorActions.setErrorMessage(err.message));
                });
        }
    },

    setShowResults: show => dispatch => {
        dispatch(_setShowResults(show));
        if (!show) dispatch(setLoader(false));
    },

    setIsWriting: isWriting => dispatch =>
        dispatch({
            type: actionTypes.setIsWriting,
            payload: {isWriting},
        }),

    setTrackId: trackId => dispatch =>
        dispatch({
            type: actionTypes.setTrackId,
            payload: {trackId},
        }),

    clearSearcher: () => dispatch =>
        dispatch({
            type: actionTypes.clearSearcher,
        }),
};
